module.exports = __webpack_public_path__ + "img/rita-robles-feranandez-byn.3e3ed662.jpg";